import id from './{id}';
import query from './query';
import get from './get';
import post from './post';

export type PostPayload = {
  apps?: number[];
  defaultApplication: number;
  forceHttps?: boolean;
  fqdn: string;
  theme: object;
};
export default { id, query, get, post };
